// services/conferenceFiltersService.js
import { API } from './api';

// API_BASE_URL is now handled by the API instance from api.js

const getUserId = async () => {
  try {
    const { getUserId: getIdUtil } = await import('../utils/auth');
    return getIdUtil();
  } catch (e) {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('userId') || 'debug-user';
    }
    return 'debug-user';
  }
};

export const conferenceFiltersService = {
  // Get all filters for current user
  async getAll() {
    try {
      const userId = await getUserId();
      const response = await API.get(`/user-filters-conference/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching conference filters:', error);
      throw error;
    }
  },

  // Save a new filter
  async save(name, filters) {
    try {
      const userId = await getUserId();
      const response = await API.post('/user-filters-conference/save', {
        userId,
        name,
        filters
      });
      return response.data;
    } catch (error) {
      console.error('Error saving conference filter:', error);
      throw error;
    }
  },

  // Get a specific filter
  async getFilter(filterId) {
    try {
      const userId = await getUserId();
      const response = await API.get(`/user-filters-conference/${filterId}?userId=${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching conference filter:', error);
      throw error;
    }
  },

  // Remove a filter
  async remove(filterId) {
    try {
      const userId = await getUserId();
      const response = await API.delete(`/user-filters-conference/${filterId}?userId=${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing conference filter:', error);
      throw error;
    }
  }
};